import React from 'react';
import './Ba.css';

const BA = () => {
  return (
    <div className="bcom-page">
      <h1 className="page-title">Bachelor of Arts</h1>
      <p className="intro-text">
  Bachelor of Arts is a 3 years full time degree program affiliated to University of Mumbai. 
  It gives students a broad foundation in the humanities, social sciences, and other liberal arts. 
  A BA degree opens up many career opportunities including teaching, media, communication, arts, culture, 
  business, public sector, and the creative industries. It has strong career prospects and helps students 
  specialize in various fields.
</p>

      {/* First Year */}
      <div className="year-section">
        <h2 className="section-title">First Year B.A (F.Y.B.A)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester I</h3>
            <ul>
              <li>History (Ancient India)</li>
              <li>Economics (Microeconomics-I)</li>
              <li>Geography</li>
              <li>Basics of Agriculture-I</li>
              <li>Introduction to Indian Archeology</li>
              <li>Indian Constitution</li>
              <li>Communication skills in English</li>
              <li>Indian Knowledge System</li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester II</h3>
            <ul>
              <li>To be updated...</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Second Year */}
      <div className="year-section">
        <h2 className="section-title">Second Year B.A (S.Y.B.A)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester III</h3>
            <ul>
              <li>Foundation Course-II</li>
              <li>Business Communication</li>
              <li>History Paper II - Landmarks in World History 1300A.D–1945A.D</li>
              <li>History Paper III - Ancient India from Earliest Time to 1000 A.D</li>
              <li>Geography of Maharashtra</li>
              <li>Agricultural Geography</li>
              <li>Macroeconomics-I</li>
              <li>Public Finance</li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester IV</h3>
            <ul>
              <li>Foundation Course-IV</li>
              <li>Business Communication</li>
              <li>History Paper II - Landmarks in World History 1300A.D–1945A.D</li>
              <li>History Paper III - Ancient India from Earliest Times to 1000 A.D</li>
              <li>Geography of India</li>
              <li>Geography of Tourism</li>
              <li>Macroeconomics-II</li>
              <li>Indian Economy</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Third Year */}
      <div className="year-section">
        <h2 className="section-title">Third Year B.A (T.Y.B.A)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester V</h3>
            <ul>
              <li>Advanced Microeconomics-III</li>
              <li>Economics of Growth and Development</li>
              <li>Economics of Agriculture and Co-Operation-I</li>
              <li>History: History of Medieval India (1000CE–1526CE)</li>
              <li>History: History of Modern Maharashtra (1818CE–1960CE)</li>
              <li>History: Introduction to Archaeology</li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester VI</h3>
            <ul>
              <li>Advanced Macroeconomics-III</li>
              <li>International Economics</li>
              <li>Economics of Agriculture and Co-Operation-II</li>
              <li>History: History of Medieval India (1526CE–1707CE)</li>
              <li>History: History of Contemporary India (1947CE–2000CE)</li>
              <li>History: Introduction to Museology and Archival Science</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BA;
